// src/state/sessionState.js
import { reactive } from "vue";

// Controla si el modal de sesión expirada está visible
export const sessionState = reactive({
  isSoftLocked: false,
});
